export const TOKEN = 'ATM_AUTH_TOKEN';

export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';

export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE';

export const PAGINATION_LIMIT = 10;
